import React, { Fragment, useState } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

import RegisterMentor from "../layout/Mentors/RegisterMentor";
import MentorLogin from "../layout/Mentors/MentorLogin";
import MessageModal from "../layout/IME/MessageModal";

import TwoFARequestMentor from "../layout/Mentors/TwoFARequestMentor";
import { clearMsg } from "../../actions/auth";
import MinimumNav from "../layout/IME/MinimumNav";

const Mentors = ({
  auth: { user, channelid, jobtitle, location, verified, msg },
  isAuthenticated,
  clearMsg,
  redirected,
}) => {
  const [showAuthentication, setShowAuthentication] = useState(true);

  if (isAuthenticated && user && user.role === "mentor") {
    return <Redirect to="/" />;
  } else {
    return (
      <Fragment>
        {verified && !isAuthenticated && (
          <TwoFARequestMentor
            setShowAuthentication={setShowAuthentication}
            channelid={channelid}
            jobtitle={jobtitle}
            location={location}
          />
        )}
        {msg && msg !== "" && (
          <MessageModal user={user} msg={msg} clearMsg={clearMsg} />
        )}
        {isAuthenticated && <MinimumNav user={user} />}
        {!isAuthenticated && <MentorLogin />}
        <div className="flex-all-content-fixed">
          <div className="main-content">
            <div className="feature-register-container">
              {/* <RegisterMentor /> */}
              <div className="coming-soon red">COMING SOON</div>
            </div>
            <section className="site-features-alt grey">
              <div className="feature-container">
                <div className="feature-name-container">
                  <p className="feature-name red bold">Innovative Mentoring</p>
                </div>
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/img/teaching.jpg"
                  }
                  className="feature-image-container"
                />
                <div className="feature-description-container">
                  <p className="feature-description">
                    As the world we live in changes around us, along with it
                    comes how we interact with one another. Innovative mentoring
                    involves utilizing cutting-edge techniques and technologies
                    to provide tailored guidance and support to mentees,
                    fostering their growth and development in unique ways.
                    Through the integration of virtual reality, AI, and other
                    advanced tools, innovative mentoring can create immersive
                    and impactful experiences that transcend traditional
                    methods.
                  </p>
                </div>
              </div>
              <div className="site-features">
                <div className="feature-container">
                  <div className="feature-name-container">
                    <p className="feature-name red bold">Mentor Live Stream</p>
                  </div>
                  <img
                    src={
                      "https://ime.sfo3.cdn.digitaloceanspaces.com/img/pexels-rpnickson-7238759.jpg"
                    }
                    className="feature-image-container"
                  />
                  <div className="feature-description-container">
                    <p className="feature-description">
                      Mentor Live Stream enables real-time communication with
                      your audience, facilitating engaging discussions about
                      success in your professional field. Subscribers can
                      connect with you live for direct conversations about the
                      ever-changing landscape of the work world.
                    </p>
                  </div>
                </div>
                <div className="site-features">
                  <div className="feature-container">
                    <div className="feature-name-container">
                      <p className="feature-name red bold">Learning Courses</p>
                    </div>
                    <img
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/img/app-browser-coffee-6335.jpg"
                      }
                      className="feature-image-container"
                    />
                    <div className="feature-description-container">
                      <p className="feature-description">
                        As a highly-regarded ime Mentor, ime offers you the
                        chance to create courses to share your expertise and
                        insights on the current state of your professional
                        field. Utilize real-world examples, tackle problems, and
                        offer resolutions while receiving constructive feedback
                        from those who purchase your course.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="site-features">
                  <div className="feature-container">
                    <div className="feature-name-container">
                      <p className="feature-name red bold">Subscribers</p>
                    </div>
                    <img
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/img/subscribers.jpg"
                      }
                      className="feature-image-container"
                    />
                    <div className="feature-description-container">
                      <p className="feature-description">
                        As your learning content grows, so can your following.
                        We offer our innovators the chance to subscribe to your
                        content, keeping them up to date with your latest live
                        stream or new learning courses.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="site-features">
                  <div className="feature-container">
                    <div className="feature-name-container">
                      <p className="feature-name red bold">Approvals</p>
                    </div>
                    <img
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/img/approval.jpg"
                      }
                      className="feature-image-container"
                    />
                    <div className="feature-description-container">
                      <p className="feature-description">
                        Endorsements from leading industry employers can enhance
                        your mentoring reputation and inspire you to share your
                        knowledge to its fullest potential. Additionally, these
                        approvals can open doors to new opportunities and
                        collaborations within your professional network.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </Fragment>
    );
  }
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  redirected: state.auth.redirected,
});

export default connect(mapStateToProps, { clearMsg })(Mentors);
